import React, { useState, useEffect } from 'react';
import { baseWhatsappUrl, message } from '../config/config';
import '../styles/styles.css';
import { Factory, Webcam, KeyRound, Hourglass, TicketPercent, Handshake, DollarSignIcon, CreditCard, Coins, Calendar, RefreshCw, UserCheck } from 'lucide-react';
import { P0M0C2, LSLSTART, LSLDOBLE, LSLOFF, LSLOFFDOBLE, LSLTOP, LSLWIN } from '../config/jairo.ts';
import { createFirstCheckoutSession } from '../api/FirstPayment.api';
import { toast, ToastContainer} from 'react-toastify';
import { useNavigate } from 'react-router-dom';


import {
  price12Cam, price11Cam, price10Cam, price9Cam,  price8Cam, price7Cam, price6Cam, price5Cam, price4Cam, price3Cam, price2Cam, price1Cam,
  price1slotLicence, price2slotLicence, price3slotLicence, price4slotLicence, price5slotLicence, price6slotLicence, price7slotLicence, price8slotLicence, price9slotLicence, price10slotLicence, price11slotLicence, price12slotLicence,
  price1yearExtension, price2yearExtension, price3yearExtension
} from '../config/jairo.ts';

import { validateSalesCode } from '../../adminDashboard/api/salesCode.api.js';


// `embedded` renders inline inside the admin layout (back goes to /adminSales) instead of a full-screen overlay.
const LisualSalesTeam = ({ embedded = false }: { embedded?: boolean }) => {

  const [error, setError] = useState<string | null>(null);
  const [name, setName] = useState<string>('');
  const [cameraQuantity, setCameraQuantity] = useState<string>('');
  const [licenceType, setLicenceType] = useState<string>('');
  const [licenceExtension, setLicenceExtension] = useState<string>('');
  const [meetCoupon, setMeetCoupon] = useState<string>('');
  const [coupon, setCoupon] = useState<string>('');
  const [total, setTotal] = useState<number>(0);
  const [totalPerCamaraPerMonth, setTotalPerCamaraPerMonth] = useState<number>(0);
  const [blocked, setBlocked] = useState<boolean>(false);
  const [prestigePartners, setPrestigePartners] = useState<boolean>(false);
  const [salePrice, setSalePrice] = useState<string>('');
  const [salesPersonCode, setSalesPersonCode] = useState<string>('');
  const [totalWODiscounts, setTotalWODiscounts] = useState<number>(0);
  const [totalPercamaraPerMonthAfterSalePrice, setTotalPercamaraPerMonthAfterSalePrice] = useState<number>(0);

  const [billingType, setBillingType] = useState<string>('mrr');
  const [mrrAmount, setMrrAmount] = useState<number>(0);
  const [oneshotAmount, setOneshotAmount] = useState<number>(0);
  const [softwareMonthsPaid, setSoftwareMonthsPaid] = useState<number>(0);
  const [isRenewal, setIsRenewal] = useState<boolean>(false);
  const [vendedor, setVendedor] = useState<string>('');
  

  const getPriceFromString = (valueString: string): number => {
    if (!valueString) return 0;
    const parts = valueString.split('_');
    const price = parseFloat(parts[parts.length - 1]);
    return isNaN(price) ? 0 : price;
  };

  const navigate = useNavigate();


  const decodeCoupon = (coupon: string): number => {
    if (!coupon) return 0;
    if (coupon === 'P0M0C2') return P0M0C2;
    if (coupon === 'LSLSTART') return LSLSTART;
    if (coupon === 'LSLDOBLE') return LSLDOBLE;
    if (coupon === 'LSLOFF') return LSLOFF;
    if (coupon === 'LSLOFFDOBLE') return LSLOFFDOBLE;
    if (coupon === 'LSLTOP') return LSLTOP;
    if (coupon === 'LSLWIN') return LSLWIN;
    return 0;
  };



  useEffect(() => {
    const camPrice = getPriceFromString(cameraQuantity);
    const totalCamPrice = camPrice * (parseInt(cameraQuantity.split('_')[0]) || 1);
    const amountOfCameras = parseInt(cameraQuantity.split('_')[0]) || 1;
    const licencePrice = getPriceFromString(licenceType);
    const extensionPrice = getPriceFromString(licenceExtension);
    const meetDiscount = decodeCoupon(meetCoupon);
    const couponDiscount = decodeCoupon(coupon);
    const extensionLicenceMounth = licenceExtension ? parseInt(licenceExtension.split('_')[0]) : 0;
    const amountSalesPrice = parseFloat(salePrice) || 0;
    //console.log("extensionLicenceMounth", extensionLicenceMounth);
    //console.log("amountOfCameras", amountOfCameras);
    const prestigePartnersCalculator = () => {
      if (prestigePartners) {
        return 58500;
      }
      return 0;
    }
    const prestigePartnersPrice = prestigePartnersCalculator();
    setTotalWODiscounts(totalCamPrice + licencePrice + extensionPrice + prestigePartnersPrice);
    setTotal(totalCamPrice + licencePrice + extensionPrice - meetDiscount - couponDiscount + prestigePartnersPrice);
    setTotalPerCamaraPerMonth(((totalCamPrice + licencePrice + extensionPrice - meetDiscount - couponDiscount + prestigePartnersPrice) / (amountOfCameras)) / (12 + (extensionLicenceMounth * 12)));
    setTotalPercamaraPerMonthAfterSalePrice(((amountSalesPrice) / (amountOfCameras)) / (12 + (extensionLicenceMounth * 12)));
}, [cameraQuantity, licenceType, licenceExtension, meetCoupon, coupon, prestigePartners, salePrice]);

const goToSalesTeam = () => {
    navigate(embedded ? '/adminSales' : '/sales');
  };


  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const numericSalePrice = parseFloat(salePrice);

    /* LIMITE DE DESCUENTO CANCELADO
    if (isNaN(numericSalePrice) || numericSalePrice < totalWODiscounts * 0.35) {  //0.65 //0.0001
    setError(`El descuento supera el 35%, no esta permitido un valor menor a ${(
      totalWODiscounts * 0.35  //0.65
    ).toFixed(2)} USD)`);
    toast.error("El descuento supera el 65%, no esta permitido");
    return; 
  }
    */

  if (salesPersonCode) {
    try {
      const validation = await validateSalesCode(salesPersonCode);
      if (!validation.valid) {
        setError("Código de comercial inválido.");
        toast.error("Código de comercial inválido.");
        return;
      }
    } catch (error) {
      setError("Código de comercial inválido.");
      toast.error("Código de comercial inválido.");
      return;
    }
  }
  
    if (blocked) {
      toast.info("Ya se está procesando un pago, por favor espera...");
      return;
    }

    // Regla de montos según el tipo de cobro
    const finalMrrAmount = (billingType === 'mrr' || billingType === 'oneshot_mrr') ? mrrAmount : 0;
    const finalOneshotAmount = (billingType === 'oneshot' || billingType === 'oneshot_mrr') ? oneshotAmount : 0;

  
    

    const formData = {
      name,
      cameraQuantity,
      licenceType,
      licenceExtension,
      meetCoupon: meetCoupon,
      coupon: coupon,
      calculatedTotal: salePrice,
      salesPersonCode,
      billingType,
      mrrAmount: finalMrrAmount,
      oneshotAmount: finalOneshotAmount,
      softwareMonthsPaid,
      isRenewal,
      vendedor
    };
    

    toast.success("Configurando el pago, por favor espera...", {
      position: "top-center",
      className: "toast-center"
    });


    console.log('Try with Form Data:', JSON.stringify(formData, null, 2));
    setBlocked(true);


    try {
      const paymentResponse = await createFirstCheckoutSession(formData);
      if (paymentResponse && paymentResponse.url) {

        console.log("Navegando a:", paymentResponse.url);
        window.location.href = paymentResponse.url;
      } else {
        console.error("La respuesta de la API no contiene una URL de redirección.");
        toast.error("Error: La API no proporcionó una URL de pago.");
      }
      setBlocked(false);
    } catch (error) {
      console.error("Error al configurar el pago", error);
      toast.error("Hubo un error al configurar el pago");
    }
  };




  return (
        <div className={embedded ? 'w-full' : 'w-full bg-blue-400 py-3'}>
          <div className={embedded ? 'flex items-center justify-center' : 'fixed inset-0 bg-blue-100 bg-opacity-50 flex items-center justify-center z-50'}>
      <div className="relative bg-white rounded-lg shadow-lg p-4 w-full max-w-2xl max-h-[90vh] overflow-y-auto">

        <h2 className="text-lg font-semibold mb-4">Genera el enlace de pago de Stripe</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="confirmationPassword" className="block text-gray-700 text-sm font-bold mb-2">
              Elegí la cantidad de cámaras y de licencias. (Los precios no incluyen I.V.A) - Expresados en U$D
            </label>
            <p className="text-sm text-gray-600">Tenes un rango maximo para modificar los valores</p>
            <p className="text-sm text-gray-600">El costo de envío está incluido</p>
            <br />

            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="salesPersonCode">Codigo personal del comercial</label>
              <div className="InputWrapper">
                <Handshake size={18} />
                <input
                  className="Input"
                  type="text"
                  id="salesPersonCode"
                  name="salesPersonCode"
                  value={salesPersonCode}
                  onChange={(e) => setSalesPersonCode(e.target.value)}
                  placeholder="Ingresa tu código"
                  required
                />
              </div>
            </div>

            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="name">Nombre de la empresa / Propietario</label>
              <div className="InputWrapper">
                <Factory size={18} />
                <input
                  className="Input"
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value.replace(/[^\w\s]/gi, ''))}
                  placeholder="Empresa o Propietario"
                  required
                />
              </div>
            </div>

            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="cameraQuantity">Cantidad de cámaras físicas</label>
              <div className="SelectContainer">
                <Webcam size={18} />
                <select
                  className="Select"
                  id="cameraQuantity"
                  name="cameraQuantity"
                  value={cameraQuantity}
                  onChange={(e) => setCameraQuantity(e.target.value)}
                  required
                >
                  <option value="" disabled>-- Selecciona la Cantidad de Cámaras --</option>
                  <option value={`1_cam_${price1Cam}`}>1 Cam = {price1Cam * 1} USD | Precio Unit: {price1Cam} USD</option>
                  <option value={`2_cam_${price2Cam}`}>2 Cam = {price2Cam * 1} USD | Precio Unit: {price2Cam} USD</option> //
                  <option value={`3_cam_${price3Cam}`}>3 Cam = {price3Cam * 3} USD | Precio Unit: {price3Cam} USD</option>
                  <option value={`4_cam_${price4Cam}`}>4 Cam = {price4Cam * 3} USD | Precio Unit: {price4Cam} USD</option> //
                  <option value={`5_cam_${price5Cam}`}>5 Cam = {price5Cam * 3} USD | Precio Unit: {price5Cam} USD</option> //
                  <option value={`6_cam_${price6Cam}`}>6 Cam = {price6Cam * 6} USD | Precio Unit: {price6Cam} USD</option> 
                  <option value={`7_cam_${price7Cam}`}>7 Cam = {price7Cam * 6} USD | Precio Unit: {price7Cam} USD</option> //
                  <option value={`8_cam_${price8Cam}`}>8 Cam = {price8Cam * 6} USD | Precio Unit: {price8Cam} USD</option> //
                  <option value={`9_cam_${price9Cam}`}>9 Cam = {price9Cam * 9} USD | Precio Unit: {price9Cam} USD</option>
                  <option value={`10_cam_${price10Cam}`}>10 Cam = {price10Cam * 9} USD | Precio Unit: {price10Cam} USD</option> //
                  <option value={`11_cam_${price11Cam}`}>11 Cam = {price11Cam * 9} USD | Precio Unit: {price11Cam} USD</option> //
                  <option value={`12_cam_${price12Cam}`}>12 Cam = {price12Cam * 12} USD | Precio Unit: {price12Cam} USD</option>
                </select>
              </div>
            </div>

            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="licenceType">Cantidad de Slots dentro del dashboard</label>
              <div className="SelectContainer">
                <KeyRound size={18} />
                <select
                  className="Select"
                  id="licenceType"
                  name="licenceType"
                  value={licenceType}
                  onChange={(e) => setLicenceType(e.target.value)}
                  required
                >
                  <option value="" disabled>-- Selecciona la Cantidad de Slots --</option>
                  <option value={`1_slot_lic_${price1slotLicence}`}>1 cámara: {price1slotLicence} USD</option>
                  <option value={`2_slot_lic_${price2slotLicence}`}>2 cámaras: {price2slotLicence} USD</option>
                  <option value={`3_slot_lic_${price3slotLicence}`}>3 cámaras: {price3slotLicence} USD</option>
                    <option value={`4_slot_lic_${price4slotLicence}`}>4 cámaras: {price4slotLicence} USD</option>
                    <option value={`5_slot_lic_${price5slotLicence}`}>5 cámaras: {price5slotLicence} USD</option>
                  <option value={`6_slot_lic_${price6slotLicence}`}>6 cámaras: {price6slotLicence} USD</option>
                    <option value={`7_slot_lic_${price7slotLicence}`}>7 cámaras: {price7slotLicence} USD</option>
                    <option value={`8_slot_lic_${price8slotLicence}`}>8 cámaras: {price8slotLicence} USD</option>
                  <option value={`9_slot_lic_${price9slotLicence}`}>9 cámaras: {price9slotLicence} USD</option>
                    <option value={`10_slot_lic_${price10slotLicence}`}>10 cámara): {price10slotLicence} USD</option>
                    <option value={`11_slot_lic_${price11slotLicence}`}>11 cámara): {price11slotLicence} USD</option>
                  <option value={`12_slot_lic_${price12slotLicence}`}>12 cámara): {price12slotLicence} USD</option>
                </select>
              </div>
            </div>

            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="licenceExtension">Período de licencia</label>
              <div className="SelectContainer">
                <Hourglass size={18} />
                <select
                  className="Select"
                  id="licenceExtension"
                  name="licenceExtension"
                  value={licenceExtension}
                  onChange={(e) => setLicenceExtension(e.target.value)}
                  required
                >
                  <option value="" disabled>-- Selecciona el Período de Licencia --</option>
                  <option value={`30_days_salesTeamPrice`}>1 mes</option>
                  <option value={`60_days_salesTeamPrice`}>2 meses </option>
                  <option value={`90_days_salesTeamPrice`}>3 meses </option>
                  <option value={`120_days_salesTeamPrice`}>4 meses </option>
                  <option value={`150_days_salesTeamPrice`}>5 meses </option>
                  <option value={`180_days_salesTeamPrice`}>1/2 año = 6 meses  </option>
                  <option value={`210_days_salesTeamPrice`}>7 meses </option>
                  <option value={`240_days_salesTeamPrice`}>8 meses </option>
                  <option value={`270_days_salesTeamPrice`}>9 meses </option>
                  <option value={`300_days_salesTeamPrice`}>10 meses </option>
                  <option value={`330_days_salesTeamPrice`}>11 meses </option>
                  <option value={`360_days_salesTeamPrice`}>1 año = 12 meses </option>
                  <option value={`390_days_salesTeamPrice`}>13 meses: </option>
                  <option value={`420_days_salesTeamPrice`}>14 meses: </option>
                  <option value={`450_days_salesTeamPrice`}>15 meses: </option>
                  <option value={`480_days_salesTeamPrice`}>16 meses: </option>
                  <option value={`510_days_salesTeamPrice`}>17 meses: </option>
                  <option value={`540_days_salesTeamPrice`}>1 año y medio = 18 meses: </option>
                  <option value={`570_days_salesTeamPrice`}>19 meses: </option>
                  <option value={`600_days_salesTeamPrice`}>20 meses: </option>
                  <option value={`630_days_salesTeamPrice`}>21 meses: </option>
                  <option value={`660_days_salesTeamPrice`}>22 meses: </option>
                  <option value={`690_days_salesTeamPrice`}>23 meses: </option>
                  <option value={`720_days_salesTeamPrice`}>2 años = 24 meses: </option>
                  <option value={`750_days_salesTeamPrice`}>25 meses: </option>
                  <option value={`780_days_salesTeamPrice`}>26 meses: </option>
                  <option value={`810_days_salesTeamPrice`}>27 meses: </option>
                  <option value={`840_days_salesTeamPrice`}>28 meses: </option>
                  <option value={`870_days_salesTeamPrice`}>29 meses: </option>
                  <option value={`900_days_salesTeamPrice`}>2 años y medio = 30 meses: </option>
                  <option value={`930_days_salesTeamPrice`}>31 meses: </option>
                  <option value={`960_days_salesTeamPrice`}>32 meses: </option>
                  <option value={`990_days_salesTeamPrice`}>33 meses: </option>
                  <option value={`1020_days_salesTeamPrice`}>34 meses: </option>
                  <option value={`1050_days_salesTeamPrice`}>35 meses: </option>
                  <option value={`1080_days_salesTeamPrice`}>3 años = 36 meses: </option>
                  <option value={`1110_days_salesTeamPrice`}>37 meses: </option>
                  <option value={`1140_days_salesTeamPrice`}>38 meses: </option>
                  <option value={`1170_days_salesTeamPrice`}>39 meses: </option>
                  <option value={`1200_days_salesTeamPrice`}>40 meses: </option>
                  <option value={`1230_days_salesTeamPrice`}>41 meses: </option>
                  <option value={`1260_days_salesTeamPrice`}>4 años = 42 meses: </option>
                  <option value={`1290_days_salesTeamPrice`}>43 meses: </option>
                  <option value={`1320_days_salesTeamPrice`}>44 meses: </option>
                  <option value={`1350_days_salesTeamPrice`}>45 meses: </option>
                  <option value={`1380_days_salesTeamPrice`}>46 meses: </option>
                  <option value={`1410_days_salesTeamPrice`}>47 meses: </option>
                  <option value={`1440_days_salesTeamPrice`}>5 años = 48 meses: </option>
                  

                  


                  
                </select>
              </div>
            </div>

            {/*

            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="meetCoupon">Bonificación por presentarte en la reunión</label>
              <div className="InputWrapper">
                <TicketPercent size={18} />
                <input
                  className="Input"
                  type="text"
                  id="meetCoupon"
                  name="meetCoupon"
                  value={meetCoupon}
                  onChange={(e) => setMeetCoupon(e.target.value)}
                  placeholder="Ingresa tu cupón"
                />
              </div>
            </div>




            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="coupon">Cupón de descuento</label>
              <div className="InputWrapper">
                <TicketPercent size={18} />
                <input
                  className="Input"
                  type="text"
                  id="coupon"
                  name="coupon"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                  placeholder="Ingresa tu cupón"
                />
              </div>
            </div>
            */}




            

            

          </div>

        
          


          {/*<div className="mt-6 text-right border-t pt-4 border-gray-200">
            <p className="text-lg font-bold text-gray-800">
              Total de venta sin descuentos: <span className="text-blue-600">U$D {totalWODiscounts.toFixed(2)}</span>
            </p>
            <p className="text-lg font-bold text-gray-800">
              Total de venta con cupones de descuento: <span className="text-blue-600">U$D {total.toFixed(2)}</span>
            </p>

            <p className="text-sm font-bold text-gray-800">
              Relación mensual precio/cámara (previo a fijar precio de venta) <span className="text-blue-600">U$D {totalPerCamaraPerMonth.toFixed(2)} x cam/mes</span>
            </p>
            </div>*/}



            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="billingType">Tipo de Cobro</label>
              <div className="SelectContainer">
                <CreditCard size={18} />
                <select
                  className="Select"
                  id="billingType"
                  name="billingType"
                  value={billingType}
                  onChange={(e) => setBillingType(e.target.value)}
                  required
                >
                  <option value="mrr">MRR (Mensual)</option>
                  <option value="oneshot">One Shot (Pago único)</option>
                  <option value="oneshot_mrr">One Shot + MRR</option>
                </select>
              </div>
            </div>

            {(billingType === 'mrr' || billingType === 'oneshot_mrr') && (
              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="mrrAmount">Monto MRR</label>
                <div className="InputWrapper">
                  <Coins size={18} />
                  <input
                    className="Input"
                    type="number"
                    id="mrrAmount"
                    value={mrrAmount}
                    onChange={(e) => setMrrAmount(parseFloat(e.target.value) || 0)}
                    placeholder="0.00"
                    required
                  />
                </div>
              </div>
            )}

            {(billingType === 'oneshot' || billingType === 'oneshot_mrr') && (
              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="oneshotAmount">Monto One Shot</label>
                <div className="InputWrapper">
                  <Coins size={18} />
                  <input
                    className="Input"
                    type="number"
                    id="oneshotAmount"
                    value={oneshotAmount}
                    onChange={(e) => setOneshotAmount(parseFloat(e.target.value) || 0)}
                    placeholder="0.00"
                    required
                  />
                </div>
              </div>
            )}

            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="softwareMonthsPaid">Meses de software</label>
              <div className="InputWrapper">
                <Calendar size={18} />
                <input
                  className="Input"
                  type="number"
                  id="softwareMonthsPaid"
                  value={softwareMonthsPaid}
                  onChange={(e) => setSoftwareMonthsPaid(parseInt(e.target.value) || 0)}
                  required
                />
              </div>
            </div>

            <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
              <label className="Label" htmlFor="vendedor">Nombre del Vendedor</label>
              <div className="InputWrapper">
                <UserCheck size={18} />
                <input
                  className="Input"
                  type="text"
                  id="vendedor"
                  value={vendedor}
                  onChange={(e) => setVendedor(e.target.value)}
                  placeholder="Ej: Batman"
                  required
                />
              </div>
            </div>

            <div className="FormGroup flex items-center gap-2" style={{ animationDelay: '0.1s', marginBottom: '1.5rem' }}>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="isRenewal"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                  checked={isRenewal}
                  onChange={(e) => setIsRenewal(e.target.checked)}
                />
                <label htmlFor="isRenewal" className="ml-2 text-sm font-medium text-gray-700 flex items-center gap-1">
                  <RefreshCw size={14} /> ¿Es una renovación?
                </label>
              </div>
            </div>


          <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
            <label className="Label text-xl" htmlFor="salePrice"> <strong>Precio de venta</strong></label>
            <div className="InputWrapper">
              <DollarSignIcon size={18} />
              <input
                  className="InputGreen"
                  type="number"
                  step="0.01"
                  min="0"
                  id="salePrice"
                  name="salePrice"
                  value={salePrice}
                  onChange={(e) => setSalePrice(e.target.value)}
                  placeholder="0000,00"
                  required
              />
            </div>
          </div>
          {error && <p className="text-red-500 text-xl italic">{error}</p>}


              <div className="flex justify-end gap-2 mt-6">

            {/*<p className="text-lg font-bold text-gray-800">
            Total de descuentos:{" "}
            {salePrice !== "" && !isNaN(parseFloat(salePrice)) ? (
                <span className="text-blue-600">
                U$D {(totalWODiscounts - parseFloat(salePrice)).toFixed(2)}
                </span>
            ) : null}
            </p>

            <p className="text-sm font-bold text-gray-800">
              Relación mensual precio/cámara: <span className="text-blue-600">U$D {totalPercamaraPerMonthAfterSalePrice.toFixed(2)} x cam/mes</span>
            </p>
          <br/>
          */}

<button
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={goToSalesTeam}
                >
                  Cancelar
                </button>
          



          
        <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Aceptar
            </button>
          </div>

        </form>
              <ToastContainer />


</div>
      </div>
      </div>
    
  );
};

export default LisualSalesTeam;
